<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div class="p-(--padding-card)">
  <ces-route-title [count]="filteredLocations.length">
    @if (currentAssetId) {
      <ces-button
        [label]="'common.buttons.add' | transloco"
        icon="add"
        (onClick)="createLocation()"
        [hasPermission]="createPermissionConfig()" />
    }
  </ces-route-title>

  @if (!currentAssetId) {
    <div class="p-(--padding-card) text-center bg-yellow-100 border border-yellow-300 rounded-(--radius-md) mb-(--space-4)">
      <p>{{ 'common.messages.noAssetSelected.locations' | transloco }}</p>
    </div>
  }

  <ces-generic-parent-grid
    (createEntity)="createLocation()"
    (deleteEntity)="deleteLocation($event)"
    (editEntity)="editLocation($event)"
    [dataLoadingCompleted]="dataLoadingCompleted"
    [entities]="filteredLocations"
    [entityDefinition]="entityDefinitionWithPermissions()" />
</div>
